import React, { createRef, useState, useEffect,  useRef } from "react";
import VectorParser from "../../../lib/vector-math-parser";
import { TextField, Paper } from "react-md";
import { ReactSVG } from "react-svg";
import MathJax from '../../../components/react-mathjax-preview';
import Canvas from "../../../components/vectors/canvas";

import "../../../css/VectorStyles.scss";
import arrowSVG from "../../../images/vectors/upper-right-arrow.svg";
import dotSVG from "../../../images/vectors/dot.svg";

const VectorAnswers = ({
  answers,
  variableMap,
  answerType,
  selectedAnswer,
  onAnswerChoice,
  vectorSettings,
  showVectorAnswer,
  correctAnswerVectors,
  vectorAnswerFormulas,
  currentQuestionID,
  freeFormVectorOptions
}) => {
  const [vectors, setVectorss] = useState([]);
  useEffect(() => {
    if (answers && answerType !== 2) {
      setVectorss(
        answers.map((answer, index) => {
          const vectorAns = VectorParser.generateAnswerVector(
            answer.vectorAnswerFormula,
            variableMap,
            vectorSettings
          );
          return vectorAns;
        })
      );
    }
  }, [answers]);

  const onAnswerClick = (event, index) => {
    //event.preventDefault();
    onAnswerChoice(answers[index].answer_id);
  };
  const onFreeResponseAnswer = (vectorAnswer, index) => {
    console.log("selectedAnswer,vectorAnswer", selectedAnswer, vectorAnswer);
    onAnswerChoice({ ...vectorAnswer });
  };
  if (answerType === 2  || answerType === 90) {
    return (
      <FreeFormVectorAnswer
        vectorSettings={vectorSettings}
        onAnswerChange={onFreeResponseAnswer}
        showVectorAnswer={showVectorAnswer}
        correctAnswerVectors={correctAnswerVectors}
        vectorAnswerFormulas={vectorAnswerFormulas}
        currentQuestionID={currentQuestionID}
        freeFormVectorOptions={freeFormVectorOptions}
      />
    );
  }
  return (
    <div className="vector-answers-container">
      {vectors.map((vector, index) => {
        if (answers === null || answers[index] === null) return
        return (
          <div
            onClick={(event) => {
              onAnswerClick(event, index);
            }} //(checked) =>{props.onAnswerChoice(checked,{qID:question.id,aID:index.toString()})}
            className="vector-answer-container"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyItems: "center",
              alignItems: "center",
              marginLeft: "80px",
            }}
          >
            {answerType === 0 ? (
              <input
                checked={
                  (answers[index] !== undefined &&
                    selectedAnswer == answers[index].answer_id) ||
                  (answers[index] !== undefined &&
                    answers[index].isChecked !== undefined &&
                    answers[index].isChecked)
                    ? true
                    : false
                }
                style={{ marginRight: "20px" }}
                id={"input" + index}
                type={"radio"}
              />
            ) : answerType === 2 ? (
              ""
            ) : (
              <input
                checked={
                  (answers[index] !== undefined &&
                    selectedAnswer !== undefined &&
                    selectedAnswer.includes(answers[index].answer_id)) ||
                  (answers[index] !== undefined &&
                    answers[index].isChecked !== undefined &&
                    answers[index].isChecked)
                    ? true
                    : false
                }
                style={{ marginRight: "20px" }}
                id={"input" + index}
                type={"checkbox"}
              />
            )}
            <VectorAnswer
              key={"vector-answer" + index}
              vector={vector}
              vectorSettings={vectorSettings}
              readOnly={answerType !== 2}
            />
          </div>
        );
      })}
    </div>
  );
};

const VectorAnswer = ({ vector, vectorSettings, readOnly = true }) => {
  const canvasRef = createRef();
  useEffect(() => {
    if (canvasRef && canvasRef.current && vector)
      canvasRef.current.drawVectors({ vectors: [vector] });
  }, [vector, canvasRef]);

  console.log(`Point 0 ::: Vector Anas Grid Settings Data => `, vectorSettings);
  return (
    <Canvas
      type="answer"
      onVectorMoved={() => console.log("onVectorMoved")}
      ref={canvasRef}
      degStepSize={5}
      magStepSize={1}
      stepDeg={false}
      readOnly={readOnly}
      isAnswer={true}
      height={vectorSettings.height}
      width={vectorSettings.width}
      rulerXPoint={vectorSettings.rulerXPoint}
      rulerYPoint={vectorSettings.rulerYPoint}
      stepSize={vectorSettings.stepSize}
      enableGrid={vectorSettings.enableGrid}
      enableBorder={vectorSettings.enableBorder}
      enableRuler={vectorSettings.enableRuler}
      enableDarkGridLine={vectorSettings.enableDarkGridLine}
      freeBodyDiagram={vectorSettings.image}
      fbdWidth={vectorSettings.stepSize * vectorSettings.imageWidthUnit}
      fbdHeight={vectorSettings.stepSize * vectorSettings.imageHeightUnit}
      fbdX={vectorSettings.imageX}
      fbdY={vectorSettings.imageY}
      gridColor={vectorSettings.gridColor}
      rulerXLabel={vectorSettings.rulerXLabel}
      rulerYLabel={vectorSettings.rulerYLabel}
      rulerNXLabel={vectorSettings.rulerNXLabel}
      rulerNYLabel={vectorSettings.rulerNYLabel}
      commonVectorSettings={vectorSettings}
      showScale={vectorSettings.showScale}
      scale={vectorSettings.scale}
    ></Canvas>
  );
};

const vectorInitValue = {
  x: 5,
  y: 5,
  strokeWidth:5,
  name: "ans",
  posX: "5",
  posY: "5",
  color: "#0aaafa",
  angleOptions: {
    angleOffset: 0,
    type: 1,
  },
  index: 1,
  initializedIndex:0
};
const colorPallete = [
  "#F79722",
  "#0AAAFA",
  "#FF5500",
  "#09B83E",
  "#34465D",
  "#E4405F",
];

const FreeFormVectorAnswer = ({
  vectorSettings,
  onAnswerChange,
  showVectorAnswer,
  correctAnswerVectors,
  vectorAnswerFormulas, 
  currentQuestionID,
  freeFormVectorOptions
}) => {
  const canvasRef = createRef();
  const [showImage,setShowImage] = useState(false);
  const [vectors, setVectors] = useState([]);
  const [vectorsCheckbox, setVectorsCheckbox] = useState([]);
  const [clickedBox, setClickedBox] = useState([]);
  const [planeType, setPlaneType] = useState(null);
  const [isInPlane, setIsInPlane] = useState(false);
  const [isOutPlane, setIsOutPlane] = useState(false);
  const [isZeroVector, setIsZeroVector] = useState(false);
  const [isAngleOrMagnitudeTextFieldChanged, setIsAngelOrMagnitudeTextFieldChanged] = useState(false);
  const focusIndex = useRef(null);
  useEffect(() => {
    if (canvasRef && canvasRef.current && vectors) {
      console.log("vectors", vectors);
      canvasRef.current.drawVectors({ vectors: vectors });
    } else {
      canvasRef.current.drawVectors({ vectors: [] });
    }
  }, [canvasRef, vectors]);

  useEffect(() => {
    setVectors([]);
    setClickedBox([]); 
    let checkedValues = []
    let _showImage = false;
    vectorAnswerFormulas.forEach((formula)=>{
      if(formula.showImage)
        _showImage = true;

      checkedValues.push(false);
    });
    setShowImage(_showImage);
    setVectorsCheckbox(checkedValues)
}, [currentQuestionID]);

  const onChange = (arg, type) => {
    onVectorMoved(arg);
    if (type === "angleMag") {
      setIsAngelOrMagnitudeTextFieldChanged(true);
    } else {
      setIsAngelOrMagnitudeTextFieldChanged(false);
    }
  }

  const handleAngleMagnitudeTextFieldChange = (val) => {
    setIsAngelOrMagnitudeTextFieldChanged(val);
  }

  const onVectorMoved = (vectorArg) => {
    const { posX, posY, x, y, index: targetIndex } = vectorArg;
    const _vectors = vectors.map((_vector, index) => {
      if (targetIndex === index) {
        return { ...vectorArg, posY, posX, x, y };
      } else {
        return { ..._vector };
      }
    });
    setVectors(_vectors);
    onAnswerChange(_vectors);
  };

  useEffect(() => {
    if (showVectorAnswer && correctAnswerVectors) {
      setVectors([...Object.values(correctAnswerVectors)]);
    }
  }, [correctAnswerVectors, showVectorAnswer]);

  useEffect(() => {
      window.addEventListener("keydown", keyDownEventFunction);

      return () => window.removeEventListener("keydown", keyDownEventFunction);
  }, []);

  const keyDownEventFunction = (e) => {
    if(e.shiftKey && (e.key === "ArrowLeft" || e.key === "ArrowRight" || e.key ==="ArrowUp" || e.key ==="ArrowDown")){
      switch (e.key) {
        case "ArrowLeft":
            e.preventDefault();
            ShiftArrowLeftPressed();
            break;
        case "ArrowRight":
            e.preventDefault();
            ShiftArrowRightPressed();
            break;
        case "ArrowUp":
            e.preventDefault();
            ShiftArrowUpPressed();
            break;
        case "ArrowDown":
            e.preventDefault();
            ShiftArrowDownPressed();
            break;     
      }
    }else{
      switch (e.key) {
        case "ArrowLeft":
            e.preventDefault();
            ArrowLeftPressed();
            break;
        case "ArrowRight":
            e.preventDefault();
            ArrowRightPressed();
            break;
        case "ArrowUp":
            e.preventDefault();
            ArrowUpPressed();
            break;
        case "ArrowDown":
            e.preventDefault();
            ArrowDownPressed();
            break;     
      }
    }
    return   
  }


  const onZeroVectorCheckboxClicked = (event, pickedVectorIndex) => {
    console.log("zero vector", pickedVectorIndex)
    setIsZeroVector(event.target.checked);
    setPlaneType("");
    setIsInPlane(false);
    setIsOutPlane(false);
    if (event.target.checked) {
      const _vectors = vectors.map((_vector, index)=> {
        if(index === pickedVectorIndex){
          return {..._vector, x:0, y:0, plane:''}
        }else{
          return _vector
        }
      })
      setVectors([..._vectors]);
      onAnswerChange(_vectors);
    }else{
      const _vectors = vectors.map((_vector, index)=> {
        if(index === pickedVectorIndex){
          return {..._vector, x:Math.trunc(parseInt(vectorSettings.widthUnit) / 2), y:Math.trunc(parseInt(vectorSettings.heightUnit) / 2)}
        }else{
          return _vector
        }
      })
      setVectors([..._vectors]);
      onAnswerChange(_vectors);
    }
  }

  const onVectorCheckboxFocused = (index) => {
    focusIndex.current = index
  }

  const onVectorCheckboxBlured = (index) => {
    focusIndex.current = null
  }

  const ArrowUpPressed = () => {
    if(focusIndex.current !== null){
      const _vectors = [];
      setVectors((vectors)=>{
        for(let i = 0;i < vectors.length; i++){
          if(vectors[i].initializedIndex === focusIndex.current){
            vectors[i].y++
          }
          _vectors.push(vectors[i]);
        }
        return  [..._vectors];
      });
      onAnswerChange([..._vectors]);
    }
  }

  const ShiftArrowUpPressed = () => {
    if(focusIndex.current !== null){
      const _vectors = [];
      setVectors((vectors)=>{
        for(let i = 0;i < vectors.length; i++){
          if(vectors[i].initializedIndex === focusIndex.current){
            vectors[i].posY++
          }
          _vectors.push(vectors[i]);
        }
        return  [..._vectors];
      });
      onAnswerChange([..._vectors]);
    }
  }

  const ArrowDownPressed = () => {
    if(focusIndex.current !== null){
      const _vectors = [];
      setVectors((vectors)=>{
        for(let i = 0;i < vectors.length; i++){
          if(vectors[i].initializedIndex === focusIndex.current){
            vectors[i].y--
          }
          _vectors.push(vectors[i]);
        }
        return  [..._vectors];
      });
      onAnswerChange([..._vectors]);
    }
  }

  const ShiftArrowDownPressed = () => {
    if(focusIndex.current !== null){
      const _vectors = [];
      setVectors((vectors)=>{
        for(let i = 0;i < vectors.length; i++){
          if(vectors[i].initializedIndex === focusIndex.current){
            vectors[i].posY--
          }
          _vectors.push(vectors[i]);
        }
        return  [..._vectors];
      });
      onAnswerChange([..._vectors]);
    }
  }

  const ArrowRightPressed = () => {
    if(focusIndex.current !== null){
      const _vectors = [];
      setVectors((vectors)=>{
        for(let i = 0;i < vectors.length; i++){
          if(vectors[i].initializedIndex === focusIndex.current){
            vectors[i].x++
          }
          _vectors.push(vectors[i]);
        }
        return  [..._vectors];
      });
      onAnswerChange([..._vectors]);
    }
  }

  const ShiftArrowRightPressed = () => {
    if(focusIndex.current !== null){
      const _vectors = [];
      setVectors((vectors)=>{
        for(let i = 0;i < vectors.length; i++){
          if(vectors[i].initializedIndex === focusIndex.current){
            vectors[i].posX++
          }
          _vectors.push(vectors[i]);
        }
        return  [..._vectors];
      });
      onAnswerChange([..._vectors]);
    }
  }

  const ArrowLeftPressed = () => {
    if(focusIndex.current !== null){
      const _vectors = [];
      setVectors((vectors)=>{
        for(let i = 0;i < vectors.length; i++){
          if(vectors[i].initializedIndex === focusIndex.current){
            vectors[i].x--
          }
          _vectors.push(vectors[i]);
        }
        return  [..._vectors];
      });
      onAnswerChange([..._vectors]);
    }
  }

  const ShiftArrowLeftPressed = () => {
    if(focusIndex.current !== null){
      const _vectors = [];
      setVectors((vectors)=>{
        for(let i = 0;i < vectors.length; i++){
          if(vectors[i].initializedIndex === focusIndex.current){
            vectors[i].posX--
          }
          _vectors.push(vectors[i]);
        }
        return  [..._vectors];
      });
      onAnswerChange([..._vectors]);
    }
  }

  const onVectorCheckboxClicked = (event, _vector, index) => {
    setPlaneType("");
    setIsInPlane(false);
    setIsOutPlane(false);
    setIsZeroVector(false);
    let checkedValues = vectorsCheckbox
    checkedValues[index] = event.target.checked 
    setVectorsCheckbox(checkedValues)
    if (event.target.checked) {
      let vectorInitial = {
          ...vectorInitValue,
          x:Math.trunc(parseInt(vectorSettings.widthUnit) / 2),
          y:Math.trunc(parseInt(vectorSettings.heightUnit) / 2),
          name: _vector.name,
          color: vectorAnswerFormulas[index].formulaColor,
          showComponents:vectorAnswerFormulas[index].showComponents,
          showAngle:vectorAnswerFormulas[index].showAngle,
          initializedIndex: index
      }

      if(!vectorAnswerFormulas[index].autoOrigin){
        vectorInitial.posX = vectorAnswerFormulas[index].xOrigin;
        vectorInitial.posY = vectorAnswerFormulas[index].yOrigin;
      }
      const newVecArr = [...vectors,
        {
          ...vectorInitial
        }
      ]
      setVectors([...newVecArr]);
      onAnswerChange([...newVecArr]);
      setClickedBox([...newVecArr]);
    } else {
      setVectors((vectors)=>{
        const _vectors = [];
        for(let i = 0;i < vectors.length; i++){
          if(vectors[i].name !== _vector.name){
            _vectors.push(vectors[i]);
          }
        }
        onAnswerChange([..._vectors]);
        setClickedBox([..._vectors]);
        return  [..._vectors];
      });
    }
  };

  const onPlaneVectorRadioSelected = (val, pickedVectorIndex) => {
    setIsZeroVector(false);
    const _vectors = vectors.map((_vector)=> {
      if(_vector.initializedIndex === pickedVectorIndex){
        if (val === "") {
          return {..._vector, x:Math.trunc(parseInt(vectorSettings.widthUnit) / 2), y:Math.trunc(parseInt(vectorSettings.heightUnit) / 2), plane: val}
        } 
        return {..._vector, x:0, y:0, plane: val}
        // return {..._vector, plane: val}
      }else{
        return _vector
      }
    })
    setVectors([..._vectors]);


  }

  const handlePlaneSelected = (event, vec) => {
    let value = event.target.value;
    setPlaneType(value);
    onPlaneVectorRadioSelected(value, vec.initializedIndex);
  }


  const handleInPlaneCheckbox = (event, vec) => {
    let value = event.target.checked;
    setIsInPlane(value);
    setIsOutPlane(false);

    let planeType = "";
    if (value === true) {
      planeType = "in-plane";
    }

    onPlaneVectorRadioSelected(planeType, vec.initializedIndex);
  }

  const handleOutPlaneCheckbox = (event, vec) => {
    let value = event.target.checked;
    setIsOutPlane(value);
    setIsInPlane(false);

    let planeType = "";
    if (value === true) {
      planeType = "out-plane";
    }

    onPlaneVectorRadioSelected(planeType, vec.initializedIndex);
  }

  console.log(`Point 0 ::: Free form Grid Settings Data => `, vectorSettings);

  console.log(`Point 0 ::: Correct Answer Vector => `, correctAnswerVectors);

  return (
    <Paper className="free-vector-resp-answer-container" zDepth={1}>
      <div className="arrow-options-container">
        <div className="arrow-options-inputs">
          <h4>Select the vector to display, then click and drag the tip of the vector{freeFormVectorOptions["show_components"] || freeFormVectorOptions["show_magnitude_angle"] ? " or enter values below to change vector" : null}. If you need more space, click and drag the stem of the vector to move it.</h4>
          <FreeFormInputs
            vectorAnswerFormulas={vectorAnswerFormulas}
            vectors={vectors}
            onChange={onChange}
            freeFormVectorOptions={freeFormVectorOptions}
          />
        </div>
      </div>
      {/* {clickedBox.length > 0 && 
      <div className="zero-vector-container">
      <h6 style={{marginRight:'5px'}}>Select For Zero Vector&nbsp;</h6>
          {clickedBox.map((_vector, index) => {
            return (
              <div className="zero-vector-container-child" key={index}>
                <input
                  type="checkbox"
                  onChange={(event) =>
                    onZeroVectorCheckboxClicked(event, index)
                  }
                  name="add-vector"
                />
                <ReactSVG
                  src={dotSVG}
                  alt="a"
                  style={{ fill: vectorAnswerFormulas[index].formulaColor }}
                  beforeInjection={(svg) => {
                    console.log("colorcode:", vectorAnswerFormulas[index].formulaColor)
                    svg.classList.add("dot-svg");
                    svg.setAttribute(
                      "style",
                      `fill: ${vectorAnswerFormulas[index].formulaColor}`
                    );
                  }}
                />
              </div>
            );
          })}
        </div>} */}
      <div className="free-vector-resp-answer-canvas">
        <Canvas
          type="answer"
          onVectorMoved={onVectorMoved}
          ref={canvasRef}
          degStepSize={5}
          magStepSize={1}
          stepDeg={false}
          readOnly={showVectorAnswer}
          isAnswer={true}
          height={vectorSettings.height}
          width={vectorSettings.width}
          stepSize={vectorSettings.stepSize}
          rulerXPoint={vectorSettings.rulerXPoint}
          rulerYPoint={vectorSettings.rulerYPoint}
          enableGrid={vectorSettings.enableGrid}
          enableBorder={vectorSettings.enableBorder}
          enableRuler={vectorSettings.enableRuler}
          enableDarkGridLine={vectorSettings.enableDarkGridLine}
          freeBodyDiagram={vectorSettings.image}
          fbdWidth={vectorSettings.stepSize * vectorSettings.imageWidthUnit}
          fbdHeight={vectorSettings.stepSize * vectorSettings.imageHeightUnit}
          fbdX={vectorSettings.imageX}
          fbdY={vectorSettings.imageY}
          gridColor={vectorSettings.gridColor}
          rulerXLabel={vectorSettings.rulerXLabel}
          rulerYLabel={vectorSettings.rulerYLabel}
          commonVectorSettings={vectorSettings}
          vectorAnswerFormulas={vectorAnswerFormulas}
          isAngleOrMagnitudeTextFieldChanged={isAngleOrMagnitudeTextFieldChanged}
          handleAngleMagnitudeTextFieldChange={handleAngleMagnitudeTextFieldChange}
          rulerNXLabel={vectorSettings.rulerNXLabel}
          rulerNYLabel={vectorSettings.rulerNYLabel}
          showScale={vectorSettings.showScale}
          scale={vectorSettings.scale}
        ></Canvas>
        <div className="arrow-container" style={{flexDirection: 'unset'}}>
          <div >
            <h6>Display vector</h6>
            {vectorAnswerFormulas.map((_vector, index) => {
              return (
                <div className="arrow-container-child" key={index}>
                  <input
                    checked={vectorsCheckbox[index]}
                    type="checkbox"
                    onChange={(event) =>
                      onVectorCheckboxClicked(event, _vector, index)
                    }
                    onFocus={() => onVectorCheckboxFocused(index)}
                    onBlur={()=> onVectorCheckboxBlured(index)}
                    name="add-vector"
                  />
                  <ReactSVG
                    src={arrowSVG}
                    alt="a"
                    style={{ fill: vectorAnswerFormulas[index].formulaColor }}
                    beforeInjection={(svg) => {
                      svg.classList.add("arrow-svg");
                      svg.setAttribute(
                        "style",
                        `fill: ${vectorAnswerFormulas[index].formulaColor}`
                      );
                    }}
                  />
                  <MathJax math={_vector && _vector.name?String.raw`$${_vector.name}$`:''} className="options-vector" />
                </div>
              );
            })}
          </div>
          {clickedBox.length > 0 &&
            <div>
              <h6> Vector = 0 </h6>
              {clickedBox.length > 0 && clickedBox.map((_vector, index) => {
                return (
                  <div className="arrow-container-child" key={index}>
                    <input
                      type="checkbox"
                      checked={isZeroVector}
                      onChange={(event) =>
                        onZeroVectorCheckboxClicked(event, index)
                      }
                      name="add-vector"
                    />
                    <ReactSVG
                      src={dotSVG}
                      alt="a"
                      style={{ fill: vectorAnswerFormulas[index] ? vectorAnswerFormulas[index].formulaColor: '#0850f7'  }}
                      beforeInjection={(svg) => {
                        svg.classList.add("dot-svg");
                        svg.setAttribute(
                          "style",
                          `fill: ${vectorAnswerFormulas[index] ? vectorAnswerFormulas[index].formulaColor: '#0850f7'}`
                        );
                      }}
                    />
                  </div>
                );
              })}
            </div>
          }
          {clickedBox.length > 0 &&
            <div style={{padding:'0px 1rem', display:'none'}}>
              <div style={{paddingTop:'4px'}}>In/Out of Plane</div>
              {clickedBox.length > 0 && clickedBox.map((_vector, index) => {
                return (
                  <div className="arrow-container-child" key={index}>
                    <div className="vector-checkbox-child" style={{marginRight:'6px'}}>
                        <input
                          id="in-plane"
                          type="checkbox"
                          checked={isInPlane}
                          onChange={(event) => handleInPlaneCheckbox(event, _vector)}
                          name="add-vector"
                        />
                          <label htmlFor="in-plane">
                              <div style={{ fontSize: '20px' }}>{"\u2297"}</div>    
                          </label>
                    </div>
                    <div className="vector-checkbox-child">
                        <input
                          type="checkbox"
                          checked={isOutPlane}
                          onChange={(event) => handleOutPlaneCheckbox(event, _vector)}
                          name="add-vector"
                          id="out-plane"
                        />
                        <label htmlFor="out-plane">
                          <div style={{ fontSize: '20px' }}>{"\u2299"}</div>
                        </label>
                    </div>
                  </div>
                );
              })}
            </div>
          }
        </div>
      </div>
    </Paper>
  );
};

//#F79722,#0AAAFA,#FF5500,#09B83E,#34465D,#E4405F
// const  FreeFormVectorAnswers = ({ vectorSettings ,onAnswerChange,showVectorAnswer,correctAnswerVectors,vectorAnswerFormulas}) => {
//   if(vectorAnswerFormulas)
//   return <Grid>
//           {
//               vectorAnswerFormulas.map((_vector,index)=>{
//                 //console.log("_vector",_vector);
//                 return <Cell size={12} key={index}>
//                 <FreeFormVectorAnswer vectorAnswerFormulas={vectorAnswerFormulas} vectorSettings={vectorSettings}  onAnswerChange={(value)=>onAnswerChange(value,index)} showVectorAnswer={showVectorAnswer} correctAnswerVector={correctAnswerVectors?correctAnswerVectors[index]:{}}/>
//               </Cell>
//               })
//           }
//         </Grid>
//         else
//           return null;
// };

const FreeFormInputs = ({ vectorAnswerFormulas, vectors, onChange, freeFormVectorOptions }) => {
  //FreeFormInput
  return vectorAnswerFormulas.map((_vector, index) => (
    <FreeFormInput
      _vector={_vector}
      index={index}
      key={index}
      vector={vectors[index] ? vectors[index] : { x: 0, y: 0 }}
      onChange={onChange}
      freeFormVectorOptions={freeFormVectorOptions}
    />
  ));
};

const calcAngleDegrees = (x, y) => {
  return Math.round((Math.atan2(y, x) * 180) / Math.PI * 10) / 10;
};

const calculateMagnitude = (x, y) => {
  const magnitude = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
  return Math.round(magnitude * 10) / 10;
};

const generateVectorComponents = (angle, mag) => {
  console.log('angle, mag',angle, mag);
  return {
    x: Math.cos(angle * (Math.PI / 180)) * parseFloat(mag),
    y: Math.sin(angle * (Math.PI / 180)) * parseFloat(mag),
  };
};

/* const onAngleMagChanged = (angle,magnitude,onVectorValueChange) => {
  const {x,y} = generateVectorComponents(angle,magnitude);
  onVectorValueChange('x',x);
  onVectorValueChange('y',y);
} */

const onAngleMagChanged = (angle,magnitude,vector,index,onChange) => {
  const {x,y} = generateVectorComponents(angle,magnitude);
  const _vector = { ...vector };
  _vector["x"] = parseFloat(x);
  _vector["y"] = parseFloat(y);
  _vector['index'] = index;
  console.debug("_vector=========", _vector)
  onChange(_vector, "angleMag");
}


const FreeFormInput = ({ _vector, index, vector, onChange,freeFormVectorOptions }) => {
  const { name } = _vector;
  const { x = 0, y = 0, z = 0 } = vector;
  const [angle,setAngle] = useState(0);
  const [magnitude,setMagnitude] = useState(0);

  const onVectorValueChange = (key, value) => {
    const _vector = { ...vector };
    _vector[key] = parseFloat(value);
    _vector['index'] = index;
    onChange(_vector);
  };

  useEffect(()=>{
    setAngle(calcAngleDegrees(x,y));
    setMagnitude(calculateMagnitude(x,y));
  },[x,y]);

  return (
    <div className="arrow-options-input-container">
      {(freeFormVectorOptions.show_components || freeFormVectorOptions.show_magnitude_angle) && <h4>
        <MathJax math={name?String.raw`$${name}$`:''} />
      </h4>}
      {freeFormVectorOptions.show_components && <TextField
        id="x-center-title"
        label="x"
        lineDirection="center"
        placeholder="x"
        value={x | ""}
        onChange={(value) => {
          console.debug("xvalue", value, typeof value);
          if (value !== "") {
            onVectorValueChange("x", value)
          }
        }}
        type="number"
        step={1}
        className="rp-ft-input-vector base-answer-box"
        style={{  minWidth:'50px',maxWidth:'110px', height: '60px', fontSize:'14px', color:'#F5F5F5', display: vector.plane === "out-plane" || vector.plane === "in-plane" ? 'none' :'block'}}
        size={2}
        fullWidth={false}
        autoComplete="off"
      />}
     {freeFormVectorOptions.show_components && <TextField
        id="y-center-title"
        label="y"
        lineDirection="center"
        placeholder="y"
        value={y | ""}
        onChange={(value) => {
          if (value !== "") {
            onVectorValueChange("y", value)
          }
        }}
        type="number"
        className="rp-ft-input-vector base-answer-box"
        style={{  minWidth:'50px',maxWidth:'110px', height: '60px', fontSize:'14px', color:'#F5F5F5', display: vector.plane === "out-plane" || vector.plane === "in-plane" ? 'none' :'block'}}
        size={2}
        step={1}
        fullWidth={false}
        autoComplete="off"
      />}
       {(vector.plane === "out-plane" || vector.plane === "in-plane") && <TextField
        id="z-center-title"
        label="z"
        lineDirection="center"
        placeholder="z"
        value={z | ""}
        onChange={(value) => {
          if (value !== "") {
            onVectorValueChange("z", value)
          }
        }}
        type="number"
        className="rp-ft-input-vector base-answer-box"
        style={{minWidth:'50px',maxWidth:'110px', height: '60px', fontSize:'14px', color:'#F5F5F5', }}
        size={10}
        fullWidth={false}
        autoComplete="off"
      />}
      {freeFormVectorOptions.show_magnitude_angle && <TextField
        className="rp-ft-input-vector base-answer-box"
        style={{  minWidth:'50px',maxWidth:'110px', height: '60px', fontSize:'14px', color:'#F5F5F5'}}
        size={2}
        fullWidth={false}
        autoComplete="off"
        id="magnitude-center-title"
        label="Magnitude"
        lineDirection="center"
        placeholder="magnitude"
        value={magnitude ? magnitude : ''}
        type="number"
        step={0.1}
        onChange={(_magnitude) => {
          console.debug("_magnitude>>>", _magnitude, typeof magnitude)
          if (_magnitude !== "") {
            onAngleMagChanged(angle,_magnitude,vector, index, onChange)
          }
        }}
      />}
      {freeFormVectorOptions.show_magnitude_angle && <TextField
        id="angle-center-title"
        label="Angle"
        lineDirection="center"
        placeholder="angle"
        value={angle ? angle : ""}
        type="number"
        onChange={(_angle) => {
          console.debug("_angle>>>", _angle, typeof _angle)
          if (_angle !== "") {
            onAngleMagChanged(_angle,magnitude,vector, index, onChange)
          }
        }}
        className="rp-ft-input-vector base-answer-box"
        style={{  minWidth:'50px',maxWidth:'110px', height: '60px', fontSize:'14px', color:'#F5F5F5',display: vector.plane === "out-plane" || vector.plane === "in-plane" ? 'none' :'block'}}
        size={2}
        fullWidth={false}
        autoComplete="off"
      /> }
    </div>
  );
};

export default VectorAnswers;
